export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5050';
export const WEB_APP_URL = process.env.REACT_APP_WEB_URL || 'http://localhost:3000';
export const STRIPE_PUB_KEY = process.env.REACT_APP_STRIPE_PUB_KEY || '';

export const disableBilling = process.env.REACT_APP_DISABLE_BILLING === 'true';
export const disableCognito = process.env.REACT_APP_DISABLE_COGNITO === 'true';
export const disableAnalytics = process.env.REACT_APP_DISABLE_ANALYTICS === 'true';
export const disableSSO = process.env.REACT_APP_DISABLE_SSO === 'true';

export const enableFeedback = process.env.REACT_APP_ENV !== 'prod';

export const DATADOG_APP_ID = process.env.REACT_APP_DATADOG_APP_ID || '';
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_VERSION || '';

export const featureAudiences = process.env.REACT_APP_FEATURE_AUDIENCES === 'true';

export const awsConfig = {
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || '',
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID || '',
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID || '',
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN_ENDPOINT || '',
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: `${WEB_APP_URL}/signup`,
      redirectSignOut: `${WEB_APP_URL}/signup`,
      responseType: 'code',
    },
  },
};
